export const SET_SCHOOL = 'SET_SCHOOL'
export const SET_STANDARDS = 'SET_STANDARDS'
export const SET_BOARDS = 'SET_BOARDS'
